﻿import { Plugin } from 'ckeditor5';
import { Dialog, ButtonView, IframeView } from 'ckeditor5';
import { OpenLinkPopupCommand } from './statisticLink/openLinkPopupCommand';

const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
    <g>
        <path d="m10.895833333333336 19.135416666666668 -2.854166666666667 2.854166666666667a2.979166666666667 2.979166666666667 0 0 1 -4.104166666666667 0l-0.9270833333333334 -0.9270833333333334a2.885416666666667 2.885416666666667 0 0 1 -0.8541666666666666 -2.0833333333333335 2.854166666666667 2.854166666666667 0 0 1 0.8541666666666666 -2.0833333333333335l6.041666666666667 -6.052083333333333a2.9166666666666665 2.9166666666666665 0 0 1 4.104166666666667 0l0.9270833333333334 0.9375000000000001A1.0416666666666667 1.0416666666666667 0 1 0 15.5625 10.416666666666668l-0.9270833333333334 -0.9270833333333334a4.989583333333334 4.989583333333334 0 0 0 -7.052083333333333 0l-6.052083333333333 6.041666666666667a4.989583333333334 4.989583333333334 0 0 0 0 7.052083333333333l0.9270833333333334 0.9270833333333334a4.979166666666667 4.979166666666667 0 0 0 7.062500000000001 0l2.84375 -2.84375a1.0416666666666667 1.0416666666666667 0 0 0 0 -1.4791666666666667 1.0416666666666667 1.0416666666666667 0 0 0 -1.46875 -0.05208333333333334Z"></path>
        <path d="m23.468750000000004 2.4583333333333335 -0.9375000000000001 -0.9270833333333334a5 5 0 0 0 -7.052083333333333 0L12.5 4.5625a1.0416666666666667 1.0416666666666667 0 1 0 1.46875 1.46875l3.0312500000000004 -3.0208333333333335a2.9062500000000004 2.9062500000000004 0 0 1 4.104166666666667 0l0.9270833333333334 0.9375000000000001a2.854166666666667 2.854166666666667 0 0 1 0.8541666666666666 2.0833333333333335 2.885416666666667 2.885416666666667 0 0 1 -0.8541666666666666 2.0833333333333335l-6.041666666666667 6.041666666666667a2.885416666666667 2.885416666666667 0 0 1 -2.0833333333333335 0.8541666666666666 2.8645833333333335 2.8645833333333335 0 0 1 -2.0833333333333335 -0.8541666666666666A1.0416666666666667 1.0416666666666667 0 0 0 10.416666666666668 15.552083333333334a4.958333333333333 4.958333333333333 0 0 0 3.5312500000000004 1.46875 4.947916666666667 4.947916666666667 0 0 0 3.5208333333333335 -1.4583333333333333l6.052083333333333 -6.052083333333333a4.989583333333334 4.989583333333334 0 0 0 0 -7.052083333333333Z"></path>
    </g>
</svg>`;

export default class StatisticLink extends Plugin {
    static get pluginName() { return "StatisticLink" };

    static get requires() {
        return [Dialog, IframeView];
    }

    init() {
        const editor = this.editor;
        const { t } = editor.locale;

        //allow linking of multiple lines (https://github.com/ckeditor/ckeditor5/issues/1068)
        //editor.model.schema.extend('softBreak', {
        //    allowAttributesOf: '$text'
        //});

        editor.commands.add('openLinkPopup', new OpenLinkPopupCommand(editor));

        editor.ui.componentFactory.add('statisticLink', locale => {
            const statisticLinkButton = new ButtonView(locale);
            statisticLinkButton.set({
                label: t('Add statistic link'),
                withText: false,
                icon: svg,
                tooltip: t('Add statistic link')
            });

            statisticLinkButton.on('execute', () => {
                editor.execute('openLinkPopup');
            });

            return statisticLinkButton;
        });
    }
};